import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-required",
	templateUrl: "required.component.html",
})
export class RequiredComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
